import { render, staticRenderFns } from "./AlterationForm.vue?vue&type=template&id=a6786b2c&"
import script from "./AlterationForm.vue?vue&type=script&lang=ts&"
export * from "./AlterationForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports